import { Link } from "@remix-run/react";
import { capitalizeInitials, slugify } from "~/lib/helpers/storehelpers";
import { ImageWithFallback } from "./ImageWithFallback";

interface StoreCardProps {
  name: string;
  detail?: string;
  imageSrc?: string | null;
  /** When true the card fills its parent instead of using a fixed 200px width. */
  fluid?: boolean;
}

export default function StoreCard({
  name,
  detail,
  imageSrc,
  fluid = false,
}: StoreCardProps) {
  const normalizedImageSrc = imageSrc?.replaceAll('"', "");
  const storePath = `/store/${slugify(name)}/home`;
  const logoLabel = `[${capitalizeInitials(name)}]`;
  const cardContent = (
    <div
      className={`bg-white rounded-xl border border-gray-200 overflow-hidden hover:shadow-lg transition-shadow ${fluid ? "w-full" : "min-w-[200px] w-[200px]"
        }`}
    >
      <div className="h-28 bg-gray-100 flex items-center justify-center">
        {normalizedImageSrc ? (
          <ImageWithFallback
            key={normalizedImageSrc}
            src={normalizedImageSrc}
            alt={name}
            className="w-full h-full object-cover"
            fallback={
              <span className="text-gray-400 text-sm">{logoLabel}</span>
            }
          />
        ) : (
          <span className="text-gray-400 text-sm">{logoLabel}</span>
        )}
      </div>
      <div className="p-3">
        <h4 className="font-medium text-gray-900 truncate">{name}</h4>
        {detail && (
          <div className="mt-1">
            <span className="text-green-600 text-sm font-medium">{detail}</span>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <Link
      to={storePath}
      className="block rounded-xl focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
    >
      {cardContent}
    </Link>
  );
}
